// import React, { useEffect, useState } from "react";
// import {
//   Row,
//   Col,
//   Input,
//   Button,
//   Alert,
//   Container,
//   Label,
//   Spinner,
// } from "reactstrap";
// import { useNavigate } from "react-router-dom";
// import { AvForm, AvField } from "availity-reactstrap-validation";
// import { getRecords } from "../../services/api.service";
// import { toast } from "react-toastify";
// import logo from "../../assets/images/logo/LoginImg.png";
// import { Link } from "react-router-dom";

// const Login = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const user = localStorage.getItem("authUser");

//     if (user) {
//       navigate("/item-intakes-list");
//     }
//   }, [navigate]);

//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [passwordVisible, setPasswordVisible] = useState(false);
//   const [isAlertShown, setIsAlertShown] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [accesMenuData, setAccesMenuData] = useState([]);
//   const [menuData, setMenuData] = useState([]);
//   const [userData, setUserData] = useState({ status: true, message: "" });

//   const fetchMenuData = async () => {
//     const payload = {
//       modelName: "menu_masters",
//       whereCondition: { is_active: true },
//       pagination: { page: 1, pageSize: 1000000 },
//     };

//     try {
//       const { code, data } = await getRecords(payload, "/getRecords");
//       if (code === 1) {
//         const indexedData = data.map((item, index) => ({
//           ...item,
//           index: index + 1,
//         }));
//         setMenuData(indexedData);
//         return indexedData;
//       }
//     } catch (error) {
//       console.error("Error fetching menu data:", error);
//     }
//     return [];
//   };

//   const fetchAccessMenuData = async (userId) => {
//     const payload = {
//       modelName: "user_access",
//       whereCondition: {
//         user_id: userId,
//         access: true,
//         is_active: true,
//       },
//       pagination: { page: 1, pageSize: 1000000 },
//     };

//     try {
//       const { code, data } = await getRecords(payload, "/getRecords");
//       if (code === 1) {
//         setAccesMenuData(data);
//         return data;
//       }
//     } catch (error) {
//       console.error("Error fetching access menu data:", error);
//     }
//     return [];
//   };

//   const filterMenus = (menuData, accessMenuData) => {
//     const allowedIds = accessMenuData.map((item) => item.menu_id);
//     return menuData.filter((menu) => allowedIds.includes(menu.id));
//   };

//   const handleSubmit = async () => {
//     setLoading(true);
//     try {
//       const payload = {
//         password,
//         modelName: "user_masters",
//         schema: "public",
//         whereCondition: { username: username },
//       };

//       const response = await getRecords(payload, "/auth/login");
//       setUserData({ status: response?.status, message: response?.message });
//       if (response?.status) {
//         const user = response.data.user;
//         if (user) {
//           localStorage.setItem(
//             "authUser",
//             JSON.stringify(response?.data?.user)
//           );
//           localStorage.setItem("schema", response?.data?.schema);
//           localStorage.setItem("token", JSON.stringify(response?.data?.token));
//           localStorage.setItem("userId", response?.data?.user?.id);
//           navigate("/item-intakes-list");
//         } else {
//           toast.error(response?.message);
//         }
//       }
//     } catch (error) {
//       console.error("Login error:", error);
//       toast.error("An error occurred. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const togglePasswordVisibility = () => {
//     setPasswordVisible(!passwordVisible);
//   };

//   return (
//     <React.Fragment>
//       <div>
//         <Container fluid className="p-0 ">
//           <Row className="g-0">
//             <Col lg={4}>
//               <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100 login-bg">
//                 <div className="w-100">
//                   <Row className="justify-content-center login-card">
//                     <Col lg={9}>
//                       <div>
//                         <div className="text-center">
//                           <div>
//                             <img
//                               src={logo}
//                               alt="Logo"
//                               height="100"
//                               className="auth-logo logo-dark mx-auto"
//                             />
//                             <img
//                               src={logo}
//                               alt="Logo"
//                               height="100"
//                               className="auth-logo logo-light mx-auto"
//                             />
//                           </div>
//                         </div>

//                         <div className="p-2">
//                           <AvForm
//                             className="form-horizontal"
//                             onValidSubmit={handleSubmit}
//                           >
//                             <div className="auth-form-group-custom mb-4">
//                               <i className="ri-user-2-line auti-custom-input-icon"></i>
//                               <Label htmlFor="username">Username</Label>
//                               <AvField
//                                 name="username"
//                                 value={username}
//                                 type="text"
//                                 className="form-control"
//                                 id="username"
//                                 placeholder="Enter username"
//                                 onChange={(e) => {
//                                   setUsername(e.target.value);
//                                   setUserData({ status: true });
//                                 }}
//                                 validate={{
//                                   required: {
//                                     value: true,
//                                     errorMessage: "Username cannot be blank.",
//                                   },
//                                   pattern: {
//                                     value: "^.{4,}$",
//                                     errorMessage:
//                                       "Please enter a valid username address",
//                                   },
//                                 }}
//                               />
//                             </div>

//                             <div className="auth-form-group-custom mb-4">
//                               <i className="ri-lock-2-line auti-custom-input-icon"></i>
//                               <Label htmlFor="userpassword">Password</Label>
//                               <AvField
//                                 name="password"
//                                 value={password}
//                                 type={passwordVisible ? "text" : "password"}
//                                 className="form-control"
//                                 id="userpassword"
//                                 placeholder="Enter password"
//                                 onChange={(e) => {
//                                   setPassword(e.target.value);
//                                   setUserData({ status: true });
//                                 }}
//                                 validate={{
//                                   required: {
//                                     value: true,
//                                     errorMessage: "Password cannot be blank.",
//                                   },
//                                 }}
//                               />
//                               {password?.length !== 0 && (
//                                 <button
//                                   type="button"
//                                   onClick={togglePasswordVisibility}
//                                   style={{
//                                     position: "absolute",
//                                     top: "54%",
//                                     right: "10px",
//                                     transform: "translateY(-50%)",
//                                     background: "transparent",
//                                     border: "none",
//                                     cursor: "pointer",
//                                   }}
//                                 >
//                                   {passwordVisible ? (
//                                     <i
//                                       className="ri-eye-line"
//                                       style={{ fontSize: "1.2em" }}
//                                     ></i>
//                                   ) : (
//                                     <i
//                                       className="ri-eye-off-line"
//                                       style={{ fontSize: "1.2em" }}
//                                     ></i>
//                                   )}
//                                 </button>
//                               )}
//                             </div>
//                             {userData.status === false && (
//                               <div className="mt-4 text-center">
//                                 <span className="text-danger">
//                                   {userData.message}
//                                 </span>
//                               </div>
//                             )}

//                             <div className="mt-4 text-center">
//                               <Button
//                                 color="primary"
//                                 className="w-md waves-effect waves-light"
//                                 type="submit"
//                                 disabled={loading}
//                                 style={{ background: "#006eb9" }}
//                               >
//                                 {loading ? "loading..." : "Log In"}
//                               </Button>
//                             </div>

//                             <div className="mt-4 text-center">
//                               <Link
//                                 to="/forgot-password"
//                                 className="text-muted"
//                               >
//                                 <i className="mdi mdi-lock me-1"></i> Forgot
//                                 your password?
//                               </Link>
//                             </div>
//                           </AvForm>
//                         </div>
//                       </div>
//                     </Col>
//                   </Row>
//                 </div>
//               </div>
//             </Col>
//             <Col lg={8}>
//               <div className="authentication-bg"></div>
//             </Col>
//           </Row>
//         </Container>
//         <style jsx>{`
//           /* GRADIENT BACKGROUND (MATCHES YOUR SCREENSHOT) */
//           .login-bg {
//             min-height: 100vh;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             background: linear-gradient(
//               135deg,
//               #d31027 0%,
//               #ea6b0b 40%,
//               #8e2de2 100%
//             );
//           }
//           .login-card {
//             background: white;
//             border-radius: 10px;
//             box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.15);
//           }
//         `}</style>

//         {loading && (
//           <div className="loading-overlay">
//             <Spinner size="lg" color="primary" />
//           </div>
//         )}
//       </div>

//       {/* Add styling for the loading overlay */}
//       <style jsx>{`
//         .loading-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background-color: rgba(0, 0, 0, 0.5);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 9999;
//         }
//       `}</style>
//     </React.Fragment>
//   );
// };

// export default Login;

import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Alert,
  Container,
  Label,
  Spinner,
} from "reactstrap";
import { useNavigate, Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { getRecords } from "../../services/api.service";
import { toast } from "react-toastify";
import logo from "../../assets/images/logo/LoginImg.png";

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("authUser");
    if (user) {
      navigate("/item-intakes-list");
    }
  }, [navigate]);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({ status: true, message: "" });

  const getLandingMenuUrl = async (roleId) => {
    const payload = {
      modelName: "menu_masters",
      schema: "public",
      whereCondition: { is_active: true },
      pagination: { page: 1, pageSize: 1000000 },
      relations: [
        {
          module: "menu_access_masters",
          moduleAs: "menu_access",
          isModuleWhereConditionRequired: true,
        },
      ],
      moduleWhereCondition: {
        role_id: roleId,
        is_active: true,
      },
    };

    const res = await getRecords(payload, "/getRecords");

    if (res?.code !== 1) return null;

    const accessibleMenus = res.data.filter((menu) =>
      menu.menu_access?.some((a) => a.access === true)
    );

    if (!accessibleMenus.length) return null;

    const dashboardMenu = accessibleMenus.find(
      (m) => m.menu_url === "/dashboard"
    );
    if (dashboardMenu) return dashboardMenu.menu_url;

    const firstValidMenu = accessibleMenus.find(
      (m) => m.menu_url && m.menu_url.trim() !== "#"
    );

    return firstValidMenu?.menu_url || null;
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        password,
        modelName: "user_masters",
        schema: "public",
        whereCondition: { username },
      };

      const response = await getRecords(payload, "/auth/login");
      setUserData({ status: response?.status, message: response?.message });

      if (response?.status) {
        const user = response.data.user;

        if (user) {
          localStorage.setItem("authUser", JSON.stringify(user));
          localStorage.setItem("schema", response?.data?.schema);
          localStorage.setItem("token", JSON.stringify(response?.data?.token));
          localStorage.setItem("userId", user?.id);

          const targetMenuUrl = await getLandingMenuUrl(user.role_id);

          if (targetMenuUrl) {
            navigate(targetMenuUrl);
            toast.success(response.message);
          } else {
            toast.error("No menu access provided to the user");
          }
        } else {
          toast.error(response?.message);
        }
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <React.Fragment>
      {/* MAIN GRADIENT BACKGROUND */}
      <div className="login-bg">
        <Container>
          <Row className="justify-content-center">
            <Col lg={4} md={6}>
              <div className="login-card">
                <div className="text-center mb-4">
                  <img src={logo} alt="Logo" height="100" className="mx-auto" />
                  {/* <h4 className="mt-3">Login</h4> */}
                </div>

                <AvForm
                  className="form-horizontal"
                  onValidSubmit={handleSubmit}
                >
                  <div className="auth-form-group-custom mb-4">
                    <Label htmlFor="username">Username</Label>
                    <AvField
                      name="username"
                      value={username}
                      type="text"
                      className="form-control"
                      id="username"
                      placeholder="Enter username"
                      onChange={(e) => {
                        setUsername(e.target.value);
                        setUserData({ status: true });
                      }}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Username cannot be blank.",
                        },
                        pattern: {
                          value: "^.{4,}$",
                          errorMessage: "Enter a valid username",
                        },
                      }}
                    />
                  </div>

                  <div className="auth-form-group-custom mb-4 position-relative">
                    <Label htmlFor="userpassword">Password</Label>
                    <AvField
                      name="password"
                      value={password}
                      type={passwordVisible ? "text" : "password"}
                      className="form-control"
                      id="userpassword"
                      placeholder="Enter password"
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setUserData({ status: true });
                      }}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Password cannot be blank.",
                        },
                      }}
                    />

                    {/* Eye Icon */}
                    {password?.length !== 0 && (
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="password-toggle"
                      >
                        {passwordVisible ? (
                          <i className="ri-eye-line"></i>
                        ) : (
                          <i className="ri-eye-off-line"></i>
                        )}
                      </button>
                    )}
                  </div>

                  {!userData.status && (
                    <div className="mt-2 text-center">
                      <span className="text-danger">{userData.message}</span>
                    </div>
                  )}

                  <div className="mt-4 text-center">
                    <Button
                      color="primary"
                      className="w-100"
                      type="submit"
                      disabled={loading}
                      style={{ background: "#006eb9" }}
                    >
                      {loading ? "Loading..." : "Log In"}
                    </Button>
                  </div>

                  {/* <div className="mt-3 text-center">
                    <Link to="/forgot-password" className="text-muted">
                      Forgot your password?
                    </Link>
                  </div> */}
                </AvForm>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Styles */}
      <style jsx>{`
        /* GRADIENT BACKGROUND (MATCHES YOUR SCREENSHOT) */
        body.loading {
          overflow: hidden !important;
        }

        .loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99999;
        }

        .login-bg {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(
            135deg,
            #d31027 0%,
            #ea6b0b 40%,
            #8e2de2 100%
          );
        }

        .login-card {
          background: white;
          padding: 40px;
          padding-top: 0;
          border-radius: 15px;
          box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.15);
          animation: fadeIn 0.4s ease-in-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .password-toggle {
          position: absolute;
          top: 60%;
          right: 12px;
          transform: translateY(-50%);
          background: transparent;
          border: none;
          cursor: pointer;
          font-size: 1.3rem;
        }
      `}</style>

      {loading && (
        <div className="loading-overlay">
          <Spinner size="lg" color="primary" />
        </div>
      )}
    </React.Fragment>
  );
};

export default Login;
